import { withPhone } from '../phoneContext';

export default withPhone;
